import { Link } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';


const Breadcrumbs = () => {
    const breadcrumbs = useBreadcrumbs();

    return (
        <Flex align="center" gap="2" mb="4">
            {breadcrumbs.map(({ match, breadcrumb }, index) => (
                <Flex key={match.pathname} align="center" gap="2">
                    <Link
                        to={match.pathname}
                        style={{
                            color: 'var(--gray-11)',
                            textDecoration: 'none'
                        }}
                    >
                        <Text size="2">
                            {breadcrumb}
                        </Text>
                    </Link>
                    {index < breadcrumbs.length - 1 && (
                        <ChevronRightIcon style={{ color: 'var(--gray-8)' }} />
                    )}
                </Flex>
            ))}
        </Flex>
    );
};

export default Breadcrumbs;
